module.exports = __webpack_public_path__ + "static/img02-45c12345d1cc593157cace8cec3da037.jpg";